<script>
    export let list = [];
    export let removeFromWhitelist;

    function excludeAccount(account) {
        if (typeof removeFromWhitelist === 'function') {
            removeFromWhitelist(account);
        }
    }
</script>

<div class="widget-wrap">
    {#each list as account}
        <div class="account-wrap mb-10px">
            <div class="username-wrap text-left">@{account.username}</div>
            <div class="remove-btn-wrap text-right">
                <a href="#" on:click={excludeAccount(account)} class="remove-btn">x</a>
            </div>
        </div>
    {/each}
</div>

<style>
    .account-wrap {
        display: flex;
        justify-content: center;
        align-items: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 14px;
    }
    .account-wrap .username-wrap {
        flex-grow: 1;
    }
    .remove-btn {
        color: #000;
        text-decoration: none;
    }
    .remove-btn:hover, .remove-btn:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
        opacity: .5;
    }
</style>